import { VaultAccount } from '@/src/hooks/apis/fireblocks/fireblocks.types';
import { useFormContext } from 'react-hook-form';
import { AccountOffer } from 'xrpl';
import { TradingFormValues } from '../../../trading.types';
import { OpenOrder } from './open-order';

type OpenOrdersBodyProps = {
  offers: AccountOffer[];
  vaultAccount: VaultAccount;
};

export const OpenOrdersBody = ({ offers, vaultAccount }: OpenOrdersBodyProps) => {
  const { watch } = useFormContext<TradingFormValues>();
  const { baseTokenId, quoteTokenId } = watch();

  return (
    <>
      {offers.map((offer, idx) => {
        return (
          <OpenOrder
            key={`${offer.seq}-${idx}`}
            offer={offer}
            baseTokenId={baseTokenId}
            quoteTokenId={quoteTokenId}
            vaultAccount={vaultAccount}
          />
        );
      })}
    </>
  );
};
